import type { SelectOptionT } from 'declarations/types/select';

type NumberWithExtraStringT = {
  number: string;
  extraString1?: string;
};

/**
 * Converts an array of advisor/tech number objects to SelectOptionT format
 * Used for creating dropdown options where the label includes the extra string if available
 */
export const convertNumbersToSelectOptions = (items: NumberWithExtraStringT[]): SelectOptionT[] => {
  return items.map(
    (item): SelectOptionT => ({
      value: item.number,
      label: item.extraString1 ? `${item.number} - ${item.extraString1}` : item.number,
    })
  );
};
